module.exports = __webpack_public_path__ + "AdobeStock_285202108_monitor2_iconcolors.svg?a51b4baea22aa9525769b7de02e2d5b4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/landing/AdobeStock_285202108_monitor2_iconcolors.svg
// module id = 326
// module chunks = 0